const images = [
  require("../../../components/MapComponent/icons/sixt_selected.png"),
];

const imagesBiciMap = [
  require("../../../components/MapComponent/icons/biciMap/poi_bicimad_blue.png"),
  require("../../../components/MapComponent/icons/biciMap/poi_bicimad_green.png"),
  require("../../../components/MapComponent/icons/biciMap/poi_bicimad_orange.png"),
  require("../../../components/MapComponent/icons/biciMap/poi_bicimad_red.png"),
  require("../../../components/MapComponent/icons/biciMap/poi_bicimad_unavailable.png"),
  require("../../../components/MapComponent/icons/biciMap/poi_bicimad_black.png"),

];




export enum META {
  SXIT = "sixt",
  BICIMAD = "bicimad",
  BIRD = 'bird',
  NEXTBIKE = 'nextbike',
  DOTT = 'dott',
  JCD = "jcdecaux",
  DONKEY = "donkey-republic",
  LYFT = "lyft"
}

export function mappingStation(data: any, l: any) {
  const groupedLocations: Record<string, any[]> = {};

  const map = data.map((t: any) => {
    const notes = t?.CoordLocation?.LocationNotes?.LocationNote || [];

    const getNote = (key: string) =>
      notes.find((item: any) => item.key === key)?.value;

    const getNotesIncludes = (key: string) =>
      notes.filter((item: any) => item.key?.includes(key));

    const providerId = getNote("PROVIDER_ID");
    const lat = t?.CoordLocation?.lat;
    const lon = t?.CoordLocation?.lon;
    const externalId = getNote("externalId");

    let openingHoursAux: any = null;

    // ✅ Helper para agrupar ciudades
    const addToGroupedLocations = (city: string) => {
      if (!groupedLocations[city]) groupedLocations[city] = [];
      groupedLocations[city].push({
        CoordLocation: { lat, lon },
      });
    };

    // =========================
    // AGRUPACIÓN POR PROVIDER
    // =========================
    if (providerId === META.SXIT) {
      const openingInfoNotes = getNotesIncludes("OPENING");
      openingHoursAux = openingInfoNotes?.map((note: any) => note.value);

      const city = getNote("CITY");
      addToGroupedLocations(city);
    }

    if (providerId === META.BICIMAD) {
      addToGroupedLocations("Madrid");
    }

    if (providerId === META.NEXTBIKE || providerId === META.DOTT) {
      const city = extractCityFromNextbikeId(getNote("mcpId"));
      addToGroupedLocations(city);
    }

    if (providerId === META.JCD) {
      const city = extractCityFromNJcdId(getNote("mcpId"));
      //console.log("city",city)
      addToGroupedLocations(city);
    }
    if (providerId === META.DONKEY) {
      const city = extractCityFromNJcdId(getNote("mcpId"));
      addToGroupedLocations(city);
    }
    if (providerId === META.LYFT) {
      const city = extractCityFromLyft(getNote("mcpId"));
      addToGroupedLocations(city);
    }



    // =========================
    // RETURN POR TIPO
    // =========================

    if (providerId === META.BICIMAD) {
      const { anchoredBike, basesAvailable } =
        baseCalculationBiciMad(notes);
      return {
        iconUrl: imagesBiciMap[0],
        type: "BiciMad",
        position: [lat, lon],
        data: {
          id: `${META.BICIMAD}_${t.CoordLocation.lat}_${t.CoordLocation.lon}`,
          lat,
          lon,
          type: "BiciMad",
          topSection: {
            title: l("planingPageLiterals.map.biciMap.aboutYourPoint"),
          },
          tags: { text: "BiciMad", color: "#3e6cc7" },
          midSection: t.CoordLocation.name,
          numberImage: mappingLevelBird(anchoredBike.toString()),
          detail: {
            anchoredBike:
              l("planingPageLiterals.map.biciMap.anchoredBike") +
              anchoredBike,
            basesAvailable:
              l("planingPageLiterals.map.biciMap.basesAvailable") +
              basesAvailable,
          },
        },
      };
    }

    if (providerId === META.SXIT) {
      return {
        iconUrl: images[0],
        type: "SIXT",
        position: [lat, lon],
        data: {
          type: "SIXT",
          id: `${META.SXIT}_${t.CoordLocation.lat}_${t.CoordLocation.lon}`,
          lat,
          lon,
          topSection: {
            title: l("planingPageLiterals.map.sixt.aboutYourPoint"),
          },
          tags: { text: "Sixt", color: "#DF6C01" },
          midSection: t.CoordLocation.name,
          downSection: t.CoordLocation.description,
          footerButtons: l("planingPageLiterals.map.sixt.footerButtons"),
          detail: {
            detail: {
              name: t?.CoordLocation?.name,
              location: getNotesIncludes("STATION_NAME")[0]?.value,
              pickupInfo: getNotesIncludes("PICKUP_INFO")[0]?.value,
              returnInfo: getNotesIncludes("RETURN_INFO")[0]?.value,
              info: openingHoursAux,
            },
          },
        },
      };
    }

    if (providerId === META.BIRD) {
      const typeVehicle = getNote("VEHICLE_TYPE");
      const fullLevel = getNote("FUEL_LEVEL_PERCENT");
      const rangeInMeter = getNote("EXPECTED_RANGE_IN_METER");

      return {
        type: `BIRD_${typeVehicle}`,
        position: [lat, lon],
        data: {
          id: `${META.BIRD}_${t.CoordLocation.lat}_${t.CoordLocation.lon}`,
          lat,
          lon,
          type: `BIRD_${typeVehicle}`,
          topSection: {
            title:
              typeVehicle === "bicycle"
                ? l("planingPageLiterals.map.bird.aboutYourPointBici")
                : l("planingPageLiterals.map.bird.aboutYourPointPatinete"),
          },
          tags: { text: "BIRD", color: "#26CCF0" },
          midSection: fullLevel + "%",
          numberImage: mappingLevelBird(fullLevel),
          iconBattery: mappingLevelIconBattery(fullLevel),
          detail: {
            electricVehicle: l(
              "planingPageLiterals.map.bird.electronicVehicle"
            ),
            autonomy:
              l("planingPageLiterals.map.bird.autonomy") +
              rangeInMeter +
              "m",
            walk:
              typeVehicle === "bicycle"
                ? l("planingPageLiterals.map.bird.walkToTheBici")
                : l("planingPageLiterals.map.bird.walkToThePatinente"),
          },
        },
      };
    }

    if (providerId === META.NEXTBIKE) {
      const { anchoredBike, basesAvailable, SLOT } =
        baseCalculationBiciMad(notes);

      return {
        iconUrl: imagesBiciMap[0],
        type: "NextBike",
        position: [lat, lon],
        data: {
          id: `${META.NEXTBIKE}_${t.CoordLocation.lat}_${t.CoordLocation.lon}`,
          lat,
          lon,
          type: "NextBike",
          topSection: {
            title: l("planingPageLiterals.map.nextBike.aboutYourPoint"),
          },
          tags: { text: "NextBike", color: "#0E4BCF" },
          midSection: t.CoordLocation.name,
          numberImage: mappingJCDECAUX(anchoredBike as any, SLOT as any),
          detail: {
            anchoredBike:
              l("planingPageLiterals.map.nextBike.anchoredBike") +
              anchoredBike,
            basesAvailable:
              l("planingPageLiterals.map.nextBike.basesAvailable") +
              basesAvailable,
          },
        },
      };
    }

    if (providerId === META.DOTT) {
      const fullLevel = getNote("FUEL_LEVEL_PERCENT");
      const rangeInMeter = getNote("EXPECTED_RANGE_IN_METER");
      return {
        type: "DOTT",
        position: [lat, lon],
        data: {
          id: `${META.DOTT}_${t.CoordLocation.lat}_${t.CoordLocation.lon}`,
          lat,
          lon,
          type: "DOTT",
          topSection: {
            title: l("planingPageLiterals.map.bird.aboutYourPointBici"),
          },
          tags: { text: "DOTT", color: "#47A7E4" },
          midSection: fullLevel + "%",
          numberImage: mappingLevelBird(fullLevel),
          iconBattery: mappingLevelIconBattery(fullLevel),
          detail: {
            electricVehicle: l(
              "planingPageLiterals.map.bird.electronicVehicle"
            ),
            autonomy:
              l("planingPageLiterals.map.bird.autonomy") +
              rangeInMeter +
              "m",
            walk: l("planingPageLiterals.map.bird.walkToTheBici"),
          },
        },
      };
    }

    if (providerId === META.JCD) {

      const { anchoredBike, basesAvailable, SLOT } = baseCalculationBiciMad(notes);
      const name =
        t?.CoordLocation?.LocationNotes?.LocationNote
          ?.find((item: any) => item?.key === "PLACE_NAME")
          ?.value
        ?? t?.CoordLocation
        ?? "-";
      return {
        type: "JCDECAUX",
        position: [lat, lon],
        data: {
          id: `${META.JCD}_${t.CoordLocation.lat}_${t.CoordLocation.lon}`,
          lat,
          lon,
          type: "JCDECAUX",
          topSection: {
            title: l("planingPageLiterals.map.bird.aboutYourPointBici"),
          },
          tags: { text: "JCDECAUX", color: "#063494" },
          midSection: name,
          numberImage: mappingJCDECAUX(anchoredBike as any, SLOT as any),

          detail: {
            anchoredBike:
              l("planingPageLiterals.map.biciMap.anchoredBike") +
              anchoredBike,
            basesAvailable:
              l("planingPageLiterals.map.biciMap.basesAvailable") +
              basesAvailable,
          },
        },
      };
    }


    if (providerId === META.DONKEY) {
      return {
        type: "DONKEY",
        position: [lat, lon],
        data: {
          id: `${META.DONKEY}_${t.CoordLocation.lat}_${t.CoordLocation.lon}`,
          lat,
          lon,
          type: "DONKEY",
          topSection: {
            title: l("planingPageLiterals.map.bird.aboutYourPointBici"),
          },
          tags: { text: "Donkey Republic ", color: "#FF6600" },
          midSection: "",
          numberImage: 1,
          detail: {
            electricVehicle: l(
              "planingPageLiterals.map.jcdecaux.humaneVehicle"
            ),
            //autonomy:l("planingPageLiterals.map.bird.autonomy") +rangeInMeter +"m",
            walk: l("planingPageLiterals.map.bird.walkToTheBici"),
          },
        },
      };
    }

    if (providerId === META.LYFT) {
      const { anchoredBike, basesAvailable } =
        baseCalculationBiciMad(notes);
      return {
        iconUrl: imagesBiciMap[0],
        type: "Lyft",
        position: [lat, lon],
        data: {
          id: `${META.BICIMAD}_${t.CoordLocation.lat}_${t.CoordLocation.lon}`,
          lat,
          lon,
          type: "Lyft",
          topSection: {
            title: l("planingPageLiterals.map.lyft.aboutYourPoint"),
          },
          tags: { text: "Lyft", color: "#FF00BF" },
          midSection: t.CoordLocation.name,
          numberImage: mappingLevelBird(anchoredBike.toString()),
          detail: {
            anchoredBike:
              l("planingPageLiterals.map.biciMap.anchoredBike") +
              anchoredBike,
            basesAvailable:
              l("planingPageLiterals.map.biciMap.basesAvailable") +
              basesAvailable,
          },
        },
      };
    }

  });

  const result = map.filter(Boolean);
  return { result, groupedLocations };
}



export function mappingPronvinaSixt(t: any) {
  const groupedLocations: { [key: string]: any[] } = {};
  const openingInfoNotes =
    t?.CoordLocation?.LocationNotes?.LocationNote?.filter((item: any) =>
      item?.key.includes("OPENING")
    );

  // Extracting 'OPENING' values
  const openingHours = openingInfoNotes?.map((note: any) => note.value);
  const nombreCiudad = t?.CoordLocation?.LocationNotes?.LocationNote?.find(
    (item: any) => item.key === "CITY"
  ).value;
  // Agrupar ubicaciones por ciudad
  if (!groupedLocations[nombreCiudad]) {
    groupedLocations[nombreCiudad] = [];
  }
  groupedLocations[nombreCiudad].push(t);

  return { groupedLocations, openingHours };
}



export function mappingOccupancyBiciMad(data: any) {
  let result = null
  const occupancy = data?.find((item: any) => item?.key === "OCCUPANCY")?.value;
  switch (occupancy) {
    case 'LOW':
      result = 1
      break;
    case 'NORMAL':
      result = 0
      break;
    case 'HIGH':
      result = 3
      break;

    default:
      result = 4
      break;
  }
  return result
}

export function baseCalculationBiciMad(data: any) {
  const getNumber = (key: string) => {
    const value = data?.find((item: any) => item?.key === key)?.value;
    const num = Number(value);
    return isNaN(num) ? null : num;
  };

  const CURRENTLY = getNumber("CURRENTLY_AVAILABLE_BOOKEES");
  const SLOT = getNumber("SLOT_COUNT");
  const AVAILABLE = getNumber("AVAILABLE_SLOTS");

  const anchoredBike = CURRENTLY ?? "/";

  const basesAvailable =
    SLOT !== null && AVAILABLE !== null
      ? `${AVAILABLE}/${SLOT}`
      : " -/-";

  return { anchoredBike, basesAvailable, SLOT };
}


export function mappingJCDECAUX(available?: number, total?: number) {
  // Si no vienen datos o total es 0 → Gris
  if (
    available === undefined ||
    total === undefined ||
    total === 0
  ) {
    return 3; // Gris
  }

  const percentage = (available / total) * 100;

  if (percentage < 25) {
    return 0; // Rojo
  }

  if (percentage >= 25 && percentage <= 60) {
    return 1; // Naranja
  }

  if (percentage > 60) {
    return 2; // Verde
  }

  return 3; // Fallback seguridad
}




export function mappingLevelBird(fullLevel: string) {
  let result = 0
  if (fullLevel === "/") {
    result = 3
  } else {
    const number = parseInt(fullLevel)
    if (number >= 0 && number < 25) {
      result = 0;
    } else if (number >= 25 && number < 60) {
      result = 1;
    } else if (number >= 60 && number <= 100) {
      result = 2;
    }
  }
  return result
}


export function mappingLevelIconBattery(fullLevel: string) {
  let result = "battery_mid"
  const number = parseInt(fullLevel)

  if (number >= 0 && number < 40) {
    result = "battery_low";
  } else if (number >= 40 && number < 60) {
    result = "battery_mid";
  } else if (number >= 60 && number <= 100) {
    result = "battery_higth";
  }
  return result
}


export const extractCityFromNextbikeId = (value: string): string => {
  if (!value) return '';

  // 1️⃣ Eliminar prefijo
  const withoutPrefix = value.replace(/^nextbike-/, '');

  // 2️⃣ Obtener parte antes de ":"
  const cityWithPossibleSuffix = withoutPrefix.split(':')[0];

  // 3️⃣ Eliminar sufijos tipo "-ey"
  const cleanCity = cityWithPossibleSuffix.replace(/-[a-z]{2}$/, '');

  // 4️⃣ Capitalizar primera letra
  return cleanCity.charAt(0).toUpperCase() + cleanCity.slice(1);
};



export const extractCityFromNJcdId = (value: string): string => {
  if (!value) return '';

  // 1️⃣ Eliminar prefijo
  const withoutPrefix = value.replace(/^jcdecaux-/, '');

  // 2️⃣ Quedarnos solo con la parte antes de ":"
  const city = withoutPrefix.split(':')[0];

  // 3️⃣ Capitalizar primera letra
  return city.charAt(0).toUpperCase() + city.slice(1);
};

export const extractCityFromLyft = (value: string): string => {
  if (!value) return '';


  return value.split('-')[1].split(':')[0];;
};


